import * as React from 'react';
import ReactPlayer from 'react-player';

import Box from '@mui/material/Box';

import PlayIcon from '../../../PlayIcon/PlayIcon';
import LazyImage from './LazyImage';

type MediaContentProps = {
  src: string;
  videoSrc?: string;
  showDownloadOption?: boolean;
  autoPlay?: boolean;
};

const PlayIconWithWaterMark: React.FC = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Box component='img' src='/png/logo-watermark.png' sx={{ width: '40%' }} />
    <PlayIcon />
  </Box>
);

const MediaContent: React.FC<MediaContentProps> = ({
  src,
  videoSrc,
  showDownloadOption = true,
  autoPlay = false,
}) => {
  return videoSrc ? (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& video': {
          objectFit: 'contain',
        },
      }}
    >
      <ReactPlayer
        width='100%'
        height='100%'
        playing={true}
        muted={autoPlay}
        url={videoSrc}
        light={autoPlay ? false : src ?? ''}
        controls
        playIcon={<PlayIconWithWaterMark />}
        config={
          showDownloadOption
            ? undefined
            : {
                file: {
                  attributes: {
                    controlsList: 'nodownload',
                  },
                },
              }
        }
      />
    </Box>
  ) : (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <LazyImage
        sx={{
          width: '100%',
          objectFit: 'cover',
        }}
        src={src}
      />
    </Box>
  );
};

export default MediaContent;
